import { render, staticRenderFns } from "./ReportGeneratorDialog.vue?vue&type=template&id=2b8167c4&scoped=true&"
import script from "./ReportGeneratorDialog.vue?vue&type=script&lang=js&"
export * from "./ReportGeneratorDialog.vue?vue&type=script&lang=js&"
import style0 from "./ReportGeneratorDialog.vue?vue&type=style&index=0&id=2b8167c4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b8167c4",
  null
  
)

export default component.exports